export enum LibraryFilter {
  Challenges = 'challenges',
  LifeSituations = 'lifeSituations',
  Types = 'types',
  ReadingTime = 'readingTime',
  SearchString = 'name',
}
